// extracted by mini-css-extract-plugin
export default {"overlay":"ModalUI_overlay__aZO-T","modal":"ModalUI_modal__K6nYg","closeButton":"ModalUI_closeButton__SHQb8","content":"ModalUI_content__EFGZC"};